import { cn } from '@ctct/summit-core';
import { Command as CommandPrimitive } from 'cmdk';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';

/**
 * Displays when no items match input search
 */
const CommandEmpty = forwardRef<
  ElementRef<typeof CommandPrimitive.Empty>,
  ComponentPropsWithoutRef<typeof CommandPrimitive.Empty>
>(({ className, ...props }, ref) => (
  <CommandPrimitive.Empty
    ref={ref}
    className={cn('rds-command-empty', 'r:py-6 r:text-center r:text-sm', className)}
    data-sds-id="command-empty"
    {...props}
  />
));

CommandEmpty.displayName = 'CommandEmpty';

export { CommandEmpty };
